export enum TipoDatos{

    PARAMETRO = 1,
    GLOSA = 2,
    SERVICIO = 3
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general/modelo/TipoDatos.ts